export const MAX_ROUTE_TEMPERATURE = 2;
export const MAX_ANTHROPIC_ROUTE_TEMPERATURE = 1;
export const MAX_ROUTE_MAX_TOKENS = 64_000;

export function maxTemperatureFor(provider: string) {
  return provider === 'anthropic' ? MAX_ANTHROPIC_ROUTE_TEMPERATURE : MAX_ROUTE_TEMPERATURE;
}

export type ParamResult = { value: number | null; error: null } | { value: null; error: string };

/** Empty input means "use the code default", sent to the API as null. */
export function parseTemperature(input: string, provider: string): ParamResult {
  const trimmed = input.trim();
  if (trimmed === '') return { value: null, error: null };

  const max = maxTemperatureFor(provider);
  const value = Number(trimmed);
  if (!Number.isFinite(value) || value < 0 || value > max) {
    return { value: null, error: `Temperature must be between 0 and ${max} for ${provider}.` };
  }
  if (!/^\d+(\.\d{1,2})?$/.test(trimmed)) {
    return { value: null, error: 'Temperature can have at most two decimals.' };
  }
  return { value, error: null };
}

export function parseMaxTokens(input: string): ParamResult {
  const trimmed = input.trim();
  if (trimmed === '') return { value: null, error: null };

  const value = Number(trimmed);
  if (!/^\d+$/.test(trimmed) || value < 1 || value > MAX_ROUTE_MAX_TOKENS) {
    return {
      value: null,
      error: `Max tokens must be a whole number between 1 and ${MAX_ROUTE_MAX_TOKENS}.`,
    };
  }
  return { value, error: null };
}
